import React from 'react';
import OTIcon from '../../../components/tag/OTIcon';
import { OTLink } from '../../../components/tag/OTLink';

function getInstructionName(instruction) {
    return instruction.split('$')[0];
}

function getInstructionLink(instruction) {
    return instruction.split('$')[1];
}

/**
 * Render instruction with given link and name
 *
 * @param name
 * @param link
 * @returns {*}
 * @constructor
 */
function Instruction({ name, link }) {
    return (
        <li style={{listStyleType: "disc"}}>
            <OTLink
                target="_blank"
                onClick={(e) => e.stopPropagation()}
                rel="noopener noreferrer"
                link={link}
                isExternal
                className="card-link"
            >
                {name}
            </OTLink>
        </li>
    );
}

/**
 * Render instructions for timeline item.
 *
 * Common instructions are fetched from linkkipalvelu with the key
 * "common". These results will be chunked and mapped to pairs with
 * name and url. The name and url are separated with $
 *
 * @param props
 * @constructor
 */
function CommonInstructions({ instructions }) {
    if (instructions == null) return null;

    const commonInstructions = instructions[0];

    return (
        <div className="span12">
            <ul className="timeline-frame-instructions-list">
                {commonInstructions &&
                commonInstructions.map((instruction, idx) => (
                    <Instruction
                        name={getInstructionName(instruction)}
                        link={getInstructionLink(instruction)}
                        key={idx}
                    />
                ))}
            </ul>
        </div>
    );
}

export default CommonInstructions;
